const handleErrors = (errorMessage: string): string => {
  switch (errorMessage) {
    case 'RoutingNumber Is Not Found':
      return 'routingNumber';
    case 'InValid Credit Card number':
      return 'cardNumber';
    default:
      return '';
  }
};

export default handleErrors;
